import React from 'react';
import WaiverDashboard from 'components/app/crm/dashboard/waivers/WaiverDashboard';

const WaiverDashboardPage = () => <WaiverDashboard />;

export default WaiverDashboardPage;
